import { MobizHttpErrorResponse } from '../data/mobiz-http-error-response.do';

import { KnownError } from './known.error';

/**
 * Error to be emitted for when a resource has not been found.
 */
export class NotFoundError extends KnownError<MobizHttpErrorResponse> {
  public readonly name: string = 'NotFoundError';
}
